import './theme/index.scss';
import ElementUI from 'element-ui';
import HsMenu from './components/menu';
import HsTable from './components/table';
import HsFormDialog from './components/formDialog';
import HsListPage from './components/listPage';
import HsTreeSelect from './components/treeSelect';
import { HsContextmenu, HsContextmenuItem } from './components/contextmenu/index.js';
import HsForm from './components/form';
import HsSearchBar from './components/searchBar';
import HsTreeTransfer from './components/treeTransfer';
import HsPagination from './components/pagination'
import HsNumberInput from './components/numberInput'

const components = [
  HsMenu,
  HsTable,
  HsContextmenu,
  HsContextmenuItem,
  HsForm,
  HsFormDialog,
  HsListPage,
  HsTreeSelect,
  HsSearchBar,
  HsTreeTransfer,
  HsPagination,
  HsNumberInput,
]

components.forEach(Cmpt => Cmpt.install = Vue => Vue.component(Cmpt.name, Cmpt))

export {
  HsMenu,
  HsTable,
  HsContextmenu,
  HsContextmenuItem,
  HsForm,
  HsFormDialog,
  HsListPage,
  HsTreeSelect,
  HsSearchBar,
  HsTreeTransfer,
  HsPagination,
  HsNumberInput,
}

export * from 'element-ui';

export default function install(Vue, option) {
  Vue.use(ElementUI, option)
  components.forEach(Cmpt => Vue.use(Cmpt))
}